import { PaginationItemType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends PaginationItemType {}

const PaginationItem: React.FC<Props> = ({
  index = 0,
  backgroundColour,
  onClick,
  disabled = false,
  progress = true,
  questionsLength = 0,
  currentQuestion = 0,
  currentPillar = 0,
}) => {
  const progressHeight = (
    questionsLength: number,
    currentQuestion: number,
    currentPillar: number,
    index: number
  ) => {
    const height: number =
      index < currentPillar || currentPillar === 0
        ? 40
        : (40 / questionsLength) * currentQuestion;

    // 40px is the full height
    return { height: `${height}px` };
  };

  const progressWidth = (
    questionsLength: number,
    currentQuestion: number,
    currentPillar: number,
    index: number
  ) => {
    const width: number =
      index < currentPillar ? 100 : (100 / questionsLength) * currentQuestion;

    // 100% is the full width, need to minus 20px for the buttons
    return { width: `${width - 20}%` };
  };

  return (
    <li className="flex-grow relative md:pl-2 -translate-y-2 md:translate-y-0">
      <button
        className={classNames(
          '-translate-x-full -translate-y-6 md:ml-0 md:translate-y-0 md:translate-x-0 w-[20px] relative group/tooltip',
          {
            'text-white': backgroundColour === 'blue',
            'text-blue': backgroundColour !== 'blue',
            'opacity-50': disabled || !progress,
          }
        )}
        onClick={() => onClick()}
        disabled={disabled}
      >
        0{index}
      </button>
      {
        /* Vert Progress Line */
        // Height is 40px
      }
      {!disabled && progress === true && (
        <span
          style={progressHeight(
            questionsLength,
            currentQuestion,
            currentPillar,
            index
          )}
          className="bg-blue-light absolute md:-left-[12px] md:top-[2px] bg-black md:block w-1 left-0 top-0 md:rotate-0 hidden foo-bar-foo"
        ></span>
      )}

      {/* Hoz line */}
      <span
        className={classNames(
          'w-1/2 max-w-[13px] h-[2px] rotate-90 md:rotate-0 block absolute -left-4 -top-1/2 md:-left-2 md:top-1/2 -translate-y-1/2',
          {
            'bg-blue/[0.50]': backgroundColour !== 'blue',
            'bg-blue-light': backgroundColour === 'blue',
            'opacity-50': disabled || !progress,
          }
        )}
      >
        &nbsp;
      </span>
      <button
        onClick={() => onClick()}
        disabled={disabled}
        className={classNames(
          'rounded-full block w-[9px] h-[9px] absolute -left-[14px] top-1/2 -translate-y-1/2 outline outline-offset-2',
          {
            'outline-blue bg-blue': backgroundColour !== 'blue',
            'outline-white bg-white': backgroundColour === 'blue',
            'opacity-50': disabled || !progress,
          }
        )}
      ></button>

      {/* Progress line for mobile */}
      {!disabled && progress === true && (
        <span
          style={progressWidth(
            questionsLength,
            currentQuestion,
            currentPillar,
            index
          )}
          className={classNames(
            'block border-b-2 border-solid border-blue-light absolute -top-full left-0 mt-[5px] md:hidden',
            {
              'opacity-50': disabled || !progress,
            }
          )}
        >
          &nbsp;
        </span>
      )}
    </li>
  );
};

export default PaginationItem;
